import * as Constants from '../constants'

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import classes from "./ContatoPage.module.css";
import { faCircleInfo, faPaperPlane, faShare } from "@fortawesome/free-solid-svg-icons";
import { useState, useEffect } from "react";
import Captcha from '../components/widget/Captcha';

function ContatoPage() {
  const [nome, setNome] = useState("");
  const [email, setEmail] = useState("");
  const [telefone, setTelefone] = useState("");
  const [mensagem, setMensagem] = useState("");
  const [f, setF] = useState("");
  const [code, setCode] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [messageSent, setMessageSent] = useState(false);

  const handleClick = async (event) => {
    event.preventDefault();

    const form = event.currentTarget.closest('form');
    const nome = form.nome.value.trim();
    const email = form.email.value.trim();
    const telefone = form.telefone.value.trim();
    const mensagem = form.mensagem.value.trim();
    const f = form.f.value.trim();
    const code = form.code.value.trim();
    const codeInput = document.getElementById('code');

    // 2. Modifica a propriedade diretamente
    if (codeInput) {
      codeInput.disabled = true;
    }

    // Validação em JavaScript
    if (!nome) {
      alert('Por favor, preencha o seu nome.');
      form.nome.focus();
      return;
    }

    if (!email) {
      alert('Por favor, preencha o seu e-mail.');
      form.email.focus();
      return;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      alert('Por favor, informe um e-mail válido.');
      form.email.focus();
      return;
    }

    if (!mensagem) {
      alert('Por favor, digite a sua mensagem.');
      form.mensagem.focus();
      return;
    }

    const dados = {
      nome,
      email,
      telefone: telefone || null,
      mensagem,
      f,
      code
    };

    if (codeInput) {
      codeInput.disabled = true;
    }

    setIsLoading(true);

    try {
      // Usando await apenas para iniciar o fetch de forma limpa
      await fetch(Constants.CONTACT, {
        method: 'POST',
        headers: {
          // REMOVIDO: 'Content-Type': 'application/json'
          'Accept': '*/*'
        },
        // O navegador define o Content-Type correto para formulários automaticamente aqui
        body: new URLSearchParams(dados),
      })
        .then(async response => {
          // console.log('HTTP:', response.status);

          // 2. PROTEÇÃO ANTI-QUEBRA: Verifica se a resposta é realmente um JSON válido antes de ler
          const contentType = response.headers.get("content-type");
          let responseJson = {};

          if (contentType && contentType.includes("application/json")) {
            responseJson = await response.json();
          } else {
            // Se o PHP retornar HTML devido ao Erro 409, pegamos como texto para não quebrar a aplicação
            const textoErro = await response.text();
            throw new Error(`Servidor não retornou JSON. Resposta: ${textoErro.substring(0, 100)}...`);
          }

          if (!response.ok) {
            throw new Error(
              responseJson.message || `Erro HTTP ${response.status}`
            );
          }

          return responseJson;
        })
        .then(responseJson => {
          if (responseJson.sucesso) {
            // console.log('Mensagem enviada:', responseJson.message);
            alert('Mensagem enviada com sucesso!');
            setNome("");
            setEmail("");
            setTelefone("");
            setMensagem("");
            setCode("");
          } else {
            alert('Não foi possível enviar mensagem');
          }
        })
        .catch(error => {
          if (error.name === 'AbortError') {
            return;
          }

          console.error(
            'Erro na requisição:',
            error.message || error
          );
        })
        .finally(() => {
          if (codeInput) {
            codeInput.disabled = false;
          }
          setIsLoading(false);
          setMessageSent(true);

          var delayInMilliseconds = 3000;
          setTimeout(function () {
            //your code to be executed after 1 second
          }, delayInMilliseconds);
          // window.location.reload();
        });
    } catch (error) {
      // setStatus("Não foi possível enviar a mensagem.");
    }
  };

  return (
    <main>
      <section id="contato" className={classes.formulario}>
        <div className="interface">
          <h2 className="titulo">FALE<span> CONOSCO.</span></h2>

          {!messageSent &&
            <form>
              <input
                type="text"
                name="nome"
                id="nome"
                value={nome}
                placeholder="* Seu nome"
                onChange={(e) => setNome(e.target.value)}
                disabled={isLoading}
              />
              <input
                type="email"
                name="email"
                id="email"
                value={email}
                placeholder="* Seu e-mail"
                onChange={(e) => setEmail(e.target.value)}
                disabled={isLoading}
              />
              <input
                type="text"
                name="telefone"
                id="telefone"
                value={telefone}
                placeholder="Seu celular"
                onChange={(e) => setTelefone(e.target.value.replace(/\D/g, "").slice(0, 13))}
                disabled={isLoading}
                maxLength={13}
              />
              <textarea
                name="mensagem"
                id="mensagem"
                value={mensagem}
                placeholder="* Sua mensagem"
                onChange={(e) => setMensagem(e.target.value)}
                disabled={isLoading}
              ></textarea>

              <Captcha
                url={"https://terradata.com.br/lib/captcha"}
              />

              <div className={classes.btnEnviar}>
                <div className={`btnContato ${classes.btnContato}`}>
                  <button type="button" onClick={handleClick} disabled={isLoading}>
                    <FontAwesomeIcon icon={faShare} />&nbsp;&nbsp;ENVIAR
                  </button>
                </div>
              </div>
            </form>
          }
          {isLoading && (<div className="loading-overlay"> <img src="/images/loading.gif" alt="Carregando..." className="loading-gif" /> </div>)}
          {messageSent &&
            <div className='col-md-12 text-center pt-3'><br /><br /><br /><br />
              <h5 className='text-light'>Mensagem enviada com sucesso!</h5>
              <br /><br />
            </div>
          }
        </div>
      </section>
      <br />
    </main >
  );
}

export default ContatoPage;